export const PROJECT_MAP_INFORMATION = "PROJECT_MAP_INFORMATION";
export const CHANGE_MAP = "CHANGE_MAP"